import CrossedLabelIcon from 'src/shared/assets/icons/label-crossed.svg';
import LabelIcon from 'src/shared/assets/icons/label.svg';
import type { TSwitcherItems } from 'src/shared/components/switcher/switcher';

export const labelSwitcherItems: TSwitcherItems = [
  {
    text: '',
    renderCompactIcon: (className) => <CrossedLabelIcon className={className} />,
  },
  {
    text: '',
    renderCompactIcon: (className) => <LabelIcon className={className} />,
  },
];

export const PLAN_VERSION_GROUP = 'planVersion';
